<template>
  <v-layout row wrap>
    <v-flex xs12 md6 lg4 v-for="approver in eligibleApprovers" :key="approver.aoid">
      <div class="select-approver">
        <v-checkbox :label="approver.name" :input-value="approverIsSelected(approver)"
                    @change="selectApprover(approver, $event)"/>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
  import ListManager from '@/views/shared/ListManager';

  export default {
    components: { ListManager },
    props: ['value', 'eligibleApprovers'],
    computed: {
      selectedApprovers() {
        return this.value.map((i) => this.eligibleApprovers[i]);
      }
    },
    methods: {
      approverIsSelected(approver) {
        return this.value.indexOf(approver.aoid) > -1;
      },
      selectApprover(approver, val) {
        const currentPos = this.value.indexOf(approver.aoid);
        if (val && currentPos < 0) {
          this.$emit('input', this.value.concat(approver.aoid));
        } else if (!val && currentPos > -1) {
          this.$emit('input', this.value.filter((i) => i !== approver.aoid));
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .select-approver {
    padding: 10px;
  }
</style>
